import { ApiError } from "@/lib/api-client";

/**
 * Traduit une erreur (idéalement une `ApiError` RFC 7807) en message lisible
 * pour l'admin — pendant client des multiples `describeError()`/`toFailure()`
 * dupliqués dans chaque fichier `lib/admin-*-actions.ts` d'apps/web (mêmes
 * messages, factorisés ici puisque ce SPA n'a plus besoin de les répéter par
 * Server Action).
 */
export function describeAdminError(err: unknown): string {
  if (err instanceof ApiError) {
    return err.problem?.detail ?? err.problem?.title ?? err.message;
  }
  if (err instanceof Error) {
    return err.message;
  }
  return "Une erreur réseau est survenue. Vérifiez votre connexion et réessayez.";
}
